// テキスト配置時の文字サイズの選好を localStorage に保存する。
// プリセット（小・中・大）と「px 指定」の任意値を扱えるよう、最終的には数値 px で保持する。

const KEY = "refinement-canvas:text:font-size";

export type TextSizeKind = "small" | "medium" | "large" | "custom";

/** プリセットの px 値。小は既存の既定サイズと一致させる（変更点を最小化するため）。 */
export const TEXT_SIZE_PRESET_PX: Record<Exclude<TextSizeKind, "custom">, number> = {
  small: 16,
  medium: 24,
  large: 40,
};

/** 「px 指定」で利用者が直接入力できる範囲。極端な値で UI が壊れないよう上下限を設ける。 */
export const TEXT_SIZE_MIN_PX = 8;
export const TEXT_SIZE_MAX_PX = 128;

/** 保存値が無いとき・壊れているときに使う既定サイズ。 */
export const DEFAULT_TEXT_FONT_SIZE: number = TEXT_SIZE_PRESET_PX.small;

/** 数値を有効な px 範囲に丸める。 */
export function clampTextFontSize(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_TEXT_FONT_SIZE;
  return Math.min(TEXT_SIZE_MAX_PX, Math.max(TEXT_SIZE_MIN_PX, Math.round(value)));
}

/** 与えられた px が「小・中・大」のいずれかと一致すれば該当 kind を、そうでなければ "custom" を返す。 */
export function resolveTextSizeKind(px: number): TextSizeKind {
  if (px === TEXT_SIZE_PRESET_PX.small) return "small";
  if (px === TEXT_SIZE_PRESET_PX.medium) return "medium";
  if (px === TEXT_SIZE_PRESET_PX.large) return "large";
  return "custom";
}

export function loadTextFontSize(): number {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === null) return DEFAULT_TEXT_FONT_SIZE;
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed)) return DEFAULT_TEXT_FONT_SIZE;
    return clampTextFontSize(parsed);
  } catch {
    return DEFAULT_TEXT_FONT_SIZE;
  }
}

export function saveTextFontSize(px: number): void {
  try {
    window.localStorage.setItem(KEY, String(clampTextFontSize(px)));
  } catch {
    // ignore（プライベートブラウジング等）
  }
}
